import { FetchResponse } from "./Types";

export const Get = async (path: string): Promise<FetchResponse> => {
	if (path.startsWith("/")) path = path.substr(1, path.length - 1);
	return (await (await fetch(`${process.env.REACT_APP_URL_SERVER}/Clientes/${path}`)).json()) as FetchResponse;
};

export const PosicionarPagina = (_top?: number) => {
	_top = _top ?? 100;
	window.scrollTo(0, _top);
};

export const ValidEmail = (mail: string): boolean => {
	var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
	return RegExp(mailformat).test(mail);
};
